<template>
  <div class="aweme-video-selector" v-loading="loading">
    <div class="top-form-row">
      <el-select v-model="form.accountId" filterable placeholder="账号" @change="onAccountChange" style="width: 200px">
        <el-option v-for="item in configForm.accounts" :key="item.id" :value="item.id" :label="item.adAccount"></el-option>
      </el-select>

      <el-input class="search-input" v-model="form.keyword" clearable placeholder="请输入达人名称关键词"></el-input>
    </div>

    <div style="min-height: 300px; max-height: 420px; overflow-y: auto">
      <AwemeVideoBox :value="selectedList" @input="onItemSelect" :data="filterdAuthedAwemeList"></AwemeVideoBox>
    </div>
    <div class="footer-btns">
      <div class="selected-preview">
        <div
          class="selected-item"
          :title="img.aweme_name + '-' + img.video_info.title"
          v-for="img in selectedList"
          :key="img.video_info.item_id"
        >
          <img style="width: 100%" :src="img.video_info.video_cover_url" alt="" />
          <em class="el-icon-error remove" @click="onItemRemove(img)"></em>
        </div>

        <span class="selected-count" v-if="selectedList.length">{{ selectedList.length }}/500</span>
      </div>
      <div class="btns">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onConfirm" :disabled="selectedList.length === 0">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject, computed } from 'vue'
import { getAuthedAwemeList, getAuthedAwemeListByStarDeliveryTaskId } from '@/api/toutiao.model'
import { getAccountById } from '@/api/ptom.data.model.js'
import AwemeVideoBox from './aweme-video-box.vue'
// eslint-disable-next-line
const props = defineProps({
  starTaskId: String
})
// eslint-disable-next-line
const emit = defineEmits(['confirm', 'update:visible', 'close'])
const { configForm } = inject('configForm')
const [firstAccount] = configForm.value.accounts

const form = ref({ accountId: firstAccount.id, keyword: '' })
const authedAwemeList = ref([])
const selectedList = ref([])
const loading = ref(false)

const filterdAuthedAwemeList = computed(() => {
  return authedAwemeList.value.filter((item) => item.aweme_name.toLowerCase().includes(form.value.keyword.toLowerCase()))
})

function onAccountChange(id) {
  getAuthedAwemeListByAccountId(id)
}
async function getAuthedAwemeListByAccountId(accountId) {
  try {
    loading.value = true

    // 关联星光联调任务的大人视频列表
    if (props.starTaskId) {
      const accountInfo = await getAccountById({ ad_account_id: accountId })
      const data = await getAuthedAwemeListByStarDeliveryTaskId({
        advertiserId: accountInfo.advertiserId,
        adAccount: accountInfo.adAccount,
        starTaskId: props.starTaskId
      })

      // 格式化，与普通达人视频格式保持一致
      authedAwemeList.value = data.map((i) => {
        return { auth_type: 'VIDEO_ITEM', aweme_id: i.aweme_id, aweme_name: i.aweme_name, video_info: { ...i, title: i.video_title } }
      })
    } else {
      // 普通达人视频列表
      authedAwemeList.value = await getAuthedAwemeList({ ad_account_id: accountId })
    }
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}

function onItemSelect(res) {
  selectedList.value = res
}

function onItemPreview(item) {
  window.open(item.video_info.aweme_play_url)
}

function onItemRemove(item) {
  selectedList.value = selectedList.value.filter((i) => i.video_info.item_id !== item.video_info.item_id)
}

function onCancel() {
  emit('close')
}
function onConfirm() {
  emit('confirm', selectedList.value)
}

getAuthedAwemeListByAccountId(firstAccount.id)
</script>

<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

@mixin desc {
  position: absolute;
  padding: 4px 6px;
  left: 0;
  width: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6);
}
.aweme-video-selector {
  .top-form-row {
    display: flex;
  }
  .search-input {
    width: 220px;
    margin-left: 10px;
  }

  .footer-btns {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .selected-count {
      position: absolute;
      left: 0;
      top: -20px;
    }
    .selected-preview {
      width: 1020px;
      overflow: auto;
      display: flex;
      gap: 2px;
      padding-bottom: 5px;
      .selected-item {
        min-width: 30px;
        max-width: 30px;
        position: relative;
        height: 32px;
        overflow: hidden;
        border-radius: 4px;
        cursor: pointer;

        .remove {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 1;
          color: $red;
          display: none;
        }
        &:hover {
          .remove {
            display: block;
          }
        }
      }
    }
  }
}
</style>
